import { Injectable }     from "@angular/core";
import { webSocket,WebSocketSubject, }   from "rxjs/webSocket";
import { Subscription,Subject }   from "rxjs";

@Injectable()
export class WebSocketService {

    private ws: WebSocketSubject<Object>;
    private socket: Subscription;
    private pingTimer: any;
    private url: string;
    private msg: string;
    private callback: Function;
    public user:{username:string,userid:string,img:string,to_userid:string,link_id:number,gerder:number}
    //   = {username:'wen',userid:'ALV3V71HJK17',img:'http://172.105.228.202/voxy/file/mode_2/20210714/60eeb5e14b9a7.jpeg',to_userid:'-1',link_id:-1,gerder:3};
      = {username:'淘妹官方帳號',userid:'TALKMATE8888',img:'6YjTQcDbKLaJLIbKOM4BU1pkBMlgouVD',to_userid:'-1',link_id:-1,gerder:3};
    public message: Subject<Object> = new Subject();
    public opened: Subject<boolean> = new Subject();

    public close():void{
        if(this.pingTimer){
            window.clearTimeout(this.pingTimer);
            this.pingTimer = null;
        }
        if(this.socket){
            this.socket.unsubscribe();
        }
        if(this.ws){
            this.ws.complete();
        }
    }

    public sendMessage( message:any ):void{
        // console.log(message);
        this.ws.next( message );
    }

    public ping(){
      this.pingTimer = window.setTimeout(()=>{
        const obj = this.get_orimsg('ping')
        this.sendMessage(obj);
        this.ping();
      },10000)
    }

    public get_orimsg(action:string){
      return {
				"type":1,
				"action":action,
				"user_id":this.user.userid,
				"user_name":this.user.username,
				"user_img":this.user.img,
				"to_userid":this.user.to_userid,
				"content":this.msg,
				"media":'',
				"category":"private",
			}
    }

    public start( url: string,callback:Function ):void{
        let self = this;
        this.callback = callback;
        this.url = url;

        this.ws = webSocket( this.url );

        this.socket = this.ws.subscribe( {

            next: ( data:MessageEvent ) => {
                if( data[ 'action' ] == "link_on" ){
                    self.opened.next( true );
                    const link_id = data['link_id'];
                    let obj = this.get_orimsg('bind');
                    let newobj = Object.assign({link_id}, obj);
                    this.user.link_id = data['link_id'];
                    this.sendMessage(newobj); 
                    this.ping();      
                }else if(['link_on','bind','online'].indexOf(data[ 'action' ]) == -1){ //初始action 不需要callback
                    callback && callback(data)
                }
                console.log('ws:',data);
               
                this.message.next( data );
            },
            error: () => {

                self.opened.next( false );
                this.message.next( { type: 'closed' } );

                self.socket.unsubscribe();

                // setTimeout( () => {
                //     self.start( self.url,this.callback );
                // }, 1000 );

            },
            complete: () => {
                this.message.next( { type: 'closed' } );
            }

        } );

    }

}